import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
  URL_SITE_SCOPED,
} from 'utils/routing/routes'

const URL_RETAILER_FUNDED_MARKETING = `${URL_RETAILER_SCOPED}/retailer-funded-marketing`
const URL_RETAILER_FUNDED_MARKETING_CREATE = `${URL_RETAILER_FUNDED_MARKETING}/create/:campaignType`
export const URL_RETAILER_FUNDED_MARKETING_LIST = `${URL_RETAILER_FUNDED_MARKETING}/list`
const URL_RETAILER_FUNDED_MARKETING_GET = `${URL_RETAILER_FUNDED_MARKETING}/:campaignId`
const URL_RETAILER_FUNDED_MARKETING_EDIT = `${URL_RETAILER_FUNDED_MARKETING}/:campaignId/edit`
const URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED = `${URL_RETAILER_FUNDED_MARKETING}${URL_SITE_SCOPED}`
const URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_CREATE = `${URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED}/create/:campaignTemplate`
const URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_LIST = `${URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED}/list`
const URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_GET = `${URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED}/:campaignId`
export const URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_EDIT = `${URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED}/:campaignId/edit`
const URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_CAMPAIGN_TEMPLATES = `${URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED}/campaign-templates`

// @hygen:inject scoped-urls

const URL_ADMIN_RETAILER_FUNDED_MARKETING = `${URL_APP_ADMIN}/retailer-funded-marketing`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'retailer-funded-marketing'>
  | DashRouteType<'app-admin-retailer-funded-marketing'>
  | DashRouteType<'retailer-funded-marketing-create'>
  | DashRouteType<'retailer-funded-marketing-list'>
  | DashRouteType<'retailer-funded-marketing-get'>
  | DashRouteType<'retailer-funded-marketing-edit'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-create'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-list'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-get'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-edit'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-campaign-templates'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-create'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-get'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-edit'>
  | DashRouteType<'retailer-funded-marketing-site-scoped-list'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'retailer-funded-marketing': URL_RETAILER_FUNDED_MARKETING,
  'app-admin-retailer-funded-marketing': URL_ADMIN_RETAILER_FUNDED_MARKETING,
  'retailer-funded-marketing-create': URL_RETAILER_FUNDED_MARKETING_CREATE,
  'retailer-funded-marketing-list': URL_RETAILER_FUNDED_MARKETING_LIST,
  'retailer-funded-marketing-get': URL_RETAILER_FUNDED_MARKETING_GET,
  'retailer-funded-marketing-edit': URL_RETAILER_FUNDED_MARKETING_EDIT,
  'retailer-funded-marketing-site-scoped-create': URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_CREATE,
  'retailer-funded-marketing-site-scoped-list': URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_LIST,
  'retailer-funded-marketing-site-scoped-get': URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_GET,
  'retailer-funded-marketing-site-scoped-edit': URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_EDIT,
  'retailer-funded-marketing-site-scoped-campaign-templates':
    URL_RETAILER_FUNDED_MARKETING_SITE_SCOPED_CAMPAIGN_TEMPLATES,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes

export type RetailerCampaignViewParams = {
  campaignId: string
}
